module.exports = __webpack_public_path__ + "img/diy-UuJuTsJi.54160c9c.svg";